import styles from './FeatureItem.scss';

import cx from 'classnames';
import React from 'react';

import { isEntry } from 'src/utils/EntryUtil';

import { Card, ICardProps } from '../../Card/Card';
import { ContentLink } from '../../ContentLink/ContentLink';
import { TextStack } from '../../TextStack/TextStack';

export const Item = React.forwardRef<HTMLAnchorElement, ICardProps>(
  ({ entry, style, className, ...props }, ref) => { // Ignoring the styles that react-slick passes down

    if (!isEntry(entry)) return null;

    const { link } = entry.fields;

    return (
      <ContentLink
        innerRef={ref}
        className={cx(styles.featureItem, className)}
        {...props}
        entry={link}
        hideTitle
        alwaysRenderChildren
      >
        <Card
          entry={entry}
          mediaClassName={styles.imageWrapper}
          captionClassName={styles.carouselCardCaption}
          className={styles.carouselCard}
          mediaProps={{
            imageWidth: 1.05,
          }}
        >
          <TextStack
            forceLinkAsSpan
            entry={entry}
            titleTagName="h5"
            linkClassName={styles.carouselItemLink}
            blurbClassName={styles.carouselItemText}
            className={styles.carouselItemContent}
            showLinkArrow
          />
        </Card>
      </ContentLink>
    );
  }
);
